import { PenguinIcon } from './PenguinIcon';

/**
 * author: Augustin Ursu
 * id B2649A8A-D1EC-43AF-9C99-F233AF709155
 * name penguin
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/penguin.svg
 * tags
 * - Animal 
 */
export const EmojiPenguinIcon = PenguinIcon;
export default EmojiPenguinIcon